import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgExpand = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="#222429"
            d="M17.5 17.5v-6.667h-1.667v3.834l-10.5-10.5h3.834V2.5H2.5v6.667h1.667V5.333l10.5 10.5h-3.834V17.5z"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgExpand)
const Memo = memo(ForwardRef)
export default Memo
